import Repository from '../axios'

const  resource = "/admin/permissions";
export default {
  get() {
    return Repository.get(`${resource}`)
  },
  updatePermissionName(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  }
};
